import { Link } from "react-router-dom";

const videos = [
    {
        id: 1,
        title: 'soon...',
        link: ''
    }
]

function Videos(props) {
    return (
        <div ref={props.videosRef} style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '190px',
            paddingTop: '20px'
        }}>
            <h1 className='title' style={{color: '#414243'}}>videos</h1>
            <h1>Coming Soon...</h1>
            {videos.map(v => (
                        <div>
                            <iframe 
                            width="300" 
                            height="315" 
                            src= {v.link} 
                            title="YouTube video player" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            referrerpolicy="strict-origin-when-cross-origin" 
                            allowfullscreen>
                            </iframe>
                        </div>
                    ))}
        </div>
    )
}

export default Videos;